import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Modal from 'components/design-system/Modal'

const text = (size, weight, color) => ({
  m: 0,
  fontFamily: 'var(--font-family-primary)',
  fontSize: `var(--font-size-${size})`,
  fontWeight: `var(--font-weight-${weight})`,
  lineHeight: 'normal',
  color: `var(--color-text-${color})`,
  whiteSpace: 'nowrap'
})

/** LICENSE (Figma 126:24484): Modal với Body = Product + Serial number + Copyright. */
const LicenseDialog = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} title="License" width={420}>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-16)', py: 'var(--space-8)', textAlign: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-4)' }}>
        <Box component="p" sx={text(16, 'bold', 'primary')}>
          Border Data Vault
        </Box>
        <Box component="p" sx={text(14, 'regular', 'secondary')}>
          Border Database Management System
        </Box>
      </Box>

      {/* Serial number — read-only Input field */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box',
          width: 252,
          height: 33,
          px: 'var(--space-16)',
          py: 'var(--space-8)',
          overflow: 'hidden',
          bgcolor: 'var(--color-bg-control)',
          border: 'var(--stroke-default) solid var(--color-border-default)',
          borderRadius: 'var(--radius-md)'
        }}
      >
        <Box component="p" sx={{ ...text(14, 'regular', 'primary'), flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          SN: NBSS-BDMS-2508-1197
        </Box>
      </Box>

      <Box component="p" sx={text(12, 'regular', 'muted')}>
        Copyright © 2025
      </Box>
    </Box>
  </Modal>
)

LicenseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default LicenseDialog
